import Menu from './Compartido/Menu.jsx';
import TextoClientes from './Clientes/TextoClientes.jsx';
import Footer from './Compartido/Footer.jsx';
import Scripts from './Compartido/Scripts.jsx';

const Clientes = (props) => {
    return (
        <main>
            <Menu
                lang={props.lang}
                meta_titulo={props.meta_titulo}
                meta_descripcion={props.meta_descripcion}
                meta_keywords={props.meta_keywords}
                ruta={props.ruta}
                config={props.websgrupo}
                pagina="5_Clientes"
                destinos={props.destinos}
                tiposcasas={props.tiposcasas}
            />
            <TextoClientes
                lang={props.lang}
                clientes={props.textoclientes}
            />
            <Footer
                lang={props.lang}
                datos={props.websgrupo}
            />
            <Scripts />
        </main>
    )
}
export default Clientes;

